<div
    class="overlay"
    *ngIf="isLoading | async"
>
    <div class="spinner-border text-dark spinner">
        <span class="sr-only">Loading...</span>
    </div>
</div>
